import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApplicantDetailsPreviewROWResponse } from "../../types";
import { previewROWResponse } from "../services/apiEndPoints";

export const fetchApplicationPreviewROW = createAsyncThunk<
  ApplicantDetailsPreviewROWResponse,
  number
>("preview/fetchApplicationPreviewROW", async (access_id) => {
  try {
    const response = await previewROWResponse({
      access_id ,
    });
    return response.data.data;
  } catch (error: any) {
    // return thunkAPI.rejectWithValue(
    //   error.response?.data || error.message || "Failed to load documents"
    // );
  }
});
